export enum EscPosOrderTypeEnum {
    TEXT = 'TEXT',
    QR = 'QR',
    FEED = 'FEED',

    IMAGE = 'IMAGE',
    DRAWER = 'DRAWER'
}
